import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
  _excluded2 = ["show", "appear", "unmount"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import m, { createContext as Z, Fragment as $, useContext as J, useEffect as F, useMemo as ee, useRef as c, useState as X } from "react";
import { useDisposables as pe } from '../../hooks/use-disposables.js';
import { useEvent as E } from '../../hooks/use-event.js';
import { useFlags as he } from '../../hooks/use-flags.js';
import { useIsMounted as ve } from '../../hooks/use-is-mounted.js';
import { useIsoMorphicEffect as ge } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as A } from '../../hooks/use-latest-value.js';
import { useServerHandoffComplete as te } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as ne } from '../../hooks/use-sync-refs.js';
import { useTransition as Ce } from '../../hooks/use-transition.js';
import { OpenClosedProvider as Ee, State as b, useOpenClosed as re } from '../../internal/open-closed.js';
import { classNames as ie } from '../../utils/class-names.js';
import { match as _ } from '../../utils/match.js';
import { Features as be, forwardRefWithAs as W, render as oe, RenderStrategy as y } from '../../utils/render.js';
function S() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return t.split(/\s+/).filter(function (n) {
    return n.length > 1;
  });
}
var I = Z(null);
I.displayName = "TransitionContext";
var Se = function (r) {
  return r.Visible = "visible", r.Hidden = "hidden", r;
}(Se || {});
function ye() {
  var t = J(I);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
function xe() {
  var t = J(M);
  if (t === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return t;
}
var M = Z(null);
M.displayName = "NestingContext";
function U(t) {
  return "children" in t ? U(t.children) : t.current.filter(function (_ref) {
    var n = _ref.el;
    return n.current !== null;
  }).filter(function (_ref2) {
    var n = _ref2.state;
    return n === "visible";
  }).length > 0;
}
function se(t, n) {
  var r = A(t),
    s = c([]),
    R = ve(),
    D = pe(),
    p = E(function (i) {
      var _ref4;
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : y.Hidden;
      var a = s.current.findIndex(function (_ref3) {
        var o = _ref3.el;
        return o === i;
      });
      a !== -1 && (_(e, (_ref4 = {}, _defineProperty(_ref4, y.Unmount, function () {
        s.current.splice(a, 1);
      }), _defineProperty(_ref4, y.Hidden, function () {
        s.current[a].state = "hidden";
      }), _ref4)), D.microTask(function () {
        var o;
        !U(s) && R.current && ((o = r.current) == null || o.call(r));
      }));
    }),
    x = E(function (i) {
      var e = s.current.find(function (_ref5) {
        var a = _ref5.el;
        return a === i;
      });
      return e ? e.state !== "visible" && (e.state = "visible") : s.current.push({
        el: i,
        state: "visible"
      }), function () {
        return p(i, y.Unmount);
      };
    }),
    h = c([]),
    v = c(Promise.resolve()),
    u = c({
      enter: [],
      leave: [],
      idle: []
    }),
    g = E(function (i, e, a) {
      h.current.splice(0), n && (n.chains.current[e] = n.chains.current[e].filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          o = _ref7[0];
        return o !== i;
      })), n == null || n.chains.current[e].push([i, new Promise(function (o) {
        h.current.push(o);
      })]), n == null || n.chains.current[e].push([i, new Promise(function (o) {
        Promise.all(u.current[e].map(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
            f = _ref9[0],
            N = _ref9[1];
          return N;
        })).then(function () {
          return o();
        });
      })]), e === "enter" ? v.current = v.current.then(function () {
        return n == null ? void 0 : n.wait.current;
      }).then(function () {
        return a(e);
      }) : a(e);
    }),
    d = E(function (i, e, a) {
      Promise.all(u.current[e].splice(0).map(function (_ref10) {
        var _ref11 = _slicedToArray(_ref10, 2),
          o = _ref11[0],
          f = _ref11[1];
        return f;
      })).then(function () {
        var o;
        (o = h.current.shift()) == null || o();
      }).then(function () {
        return a(e);
      });
    });
  return ee(function () {
    return {
      children: s,
      register: x,
      unregister: p,
      onStart: g,
      onStop: d,
      wait: v,
      chains: u
    };
  }, [x, p, s, g, d, u, v]);
}
function Ne() {}
var Pe = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function ae(t) {
  var r;
  var n = {};
  var _iterator = _createForOfIteratorHelper(Pe),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var s = _step.value;
      n[s] = (r = t[s]) != null ? r : Ne;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return n;
}
function Re(t) {
  var n = c(ae(t));
  return F(function () {
    n.current = ae(t);
  }, [t]), n;
}
var De = "div",
  le = be.RenderStrategy;
function He(t, n) {
  var _ref13;
  var Q, Y;
  var r = t.beforeEnter,
    s = t.afterEnter,
    R = t.beforeLeave,
    D = t.afterLeave,
    p = t.enter,
    x = t.enterFrom,
    h = t.enterTo,
    v = t.entered,
    u = t.leave,
    g = t.leaveFrom,
    d = t.leaveTo,
    i = _objectWithoutProperties(t, _excluded),
    e = c(null),
    a = ne(e, n),
    o = (Q = i.unmount) == null || Q ? y.Unmount : y.Hidden,
    _ye = ye(),
    f = _ye.show,
    N = _ye.appear,
    T = _ye.initial,
    _X = X(f ? "visible" : "hidden"),
    _X2 = _slicedToArray(_X, 2),
    l = _X2[0],
    j = _X2[1],
    z = xe(),
    L = z.register,
    O = z.unregister;
  F(function () {
    return L(e);
  }, [L, e]), F(function () {
    if (o === y.Hidden && e.current) {
      var _ref12;
      if (f && l !== "visible") {
        j("visible");
        return;
      }
      return _(l, (_ref12 = {}, _defineProperty(_ref12, "hidden", function hidden() {
        return O(e);
      }), _defineProperty(_ref12, "visible", function visible() {
        return L(e);
      }), _ref12));
    }
  }, [l, e, L, O, f, o]);
  var k = A({
      base: S(i.className),
      enter: S(p),
      enterFrom: S(x),
      enterTo: S(h),
      entered: S(v),
      leave: S(u),
      leaveFrom: S(g),
      leaveTo: S(d)
    }),
    V = Re({
      beforeEnter: r,
      afterEnter: s,
      beforeLeave: R,
      afterLeave: D
    }),
    G = te();
  F(function () {
    if (G && l === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [e, l, G]);
  var Te = T && !N,
    K = N && f && T,
    de = function () {
      return !G || Te ? "idle" : f ? "enter" : "leave";
    }(),
    H = he(0),
    fe = E(function (C) {
      return _(C, {
        enter: function enter() {
          H.addFlag(b.Opening), V.current.beforeEnter();
        },
        leave: function leave() {
          H.addFlag(b.Closing), V.current.beforeLeave();
        },
        idle: function idle() {}
      });
    }),
    me = E(function (C) {
      return _(C, {
        enter: function enter() {
          H.removeFlag(b.Opening), V.current.afterEnter();
        },
        leave: function leave() {
          H.removeFlag(b.Closing), V.current.afterLeave();
        },
        idle: function idle() {}
      });
    }),
    w = se(function () {
      j("hidden"), O(e);
    }, z),
    B = c(!1);
  Ce({
    immediate: K,
    container: e,
    classes: k,
    direction: de,
    onStart: A(function (C) {
      B.current = !0, w.onStart(e, C, fe);
    }),
    onStop: A(function (C) {
      B.current = !1, w.onStop(e, C, me), C === "leave" && !U(w) && (j("hidden"), O(e));
    })
  });
  var P = i,
    ce = {
      ref: a
    };
  return K ? P = _objectSpread(_objectSpread({}, P), {}, {
    className: ie.apply(void 0, [i.className].concat(_toConsumableArray(k.current.enter), _toConsumableArray(k.current.enterFrom)))
  }) : B.current && (P.className = ie(i.className, (Y = e.current) == null ? void 0 : Y.className), P.className === "" && delete P.className), m.createElement(M.Provider, {
    value: w
  }, m.createElement(Ee, {
    value: _(l, (_ref13 = {}, _defineProperty(_ref13, "visible", b.Open), _defineProperty(_ref13, "hidden", b.Closed), _ref13)) | H.flags
  }, oe({
    ourProps: ce,
    theirProps: P,
    defaultTag: De,
    features: le,
    visible: l === "visible",
    name: "Transition.Child"
  })));
}
function Fe(t, n) {
  var r = t.show,
    _t$appear = t.appear,
    s = _t$appear === void 0 ? !1 : _t$appear,
    _t$unmount = t.unmount,
    R = _t$unmount === void 0 ? !0 : _t$unmount,
    D = _objectWithoutProperties(t, _excluded2),
    p = c(null),
    x = ne(p, n);
  te();
  var h = re();
  if (r === void 0 && h !== null && (r = (h & b.Open) === b.Open), ![!0, !1].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  var _X3 = X(r ? "visible" : "hidden"),
    _X4 = _slicedToArray(_X3, 2),
    v = _X4[0],
    u = _X4[1],
    g = se(function () {
      u("hidden");
    }),
    _X5 = X(!0),
    _X6 = _slicedToArray(_X5, 2),
    d = _X6[0],
    i = _X6[1],
    e = c([r]);
  ge(function () {
    d !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), i(!1));
  }, [e, r]);
  var a = ee(function () {
    return {
      show: r,
      appear: s,
      initial: d
    };
  }, [r, s, d]);
  F(function () {
    if (r) u("visible");else if (!U(g)) u("hidden");else {
      var T = p.current;
      if (!T) return;
      var l = T.getBoundingClientRect();
      l.x === 0 && l.y === 0 && l.width === 0 && l.height === 0 && u("hidden");
    }
  }, [r, g]);
  var o = {
      unmount: R
    },
    f = E(function () {
      var T;
      d && i(!1), (T = t.beforeEnter) == null || T.call(t);
    }),
    N = E(function () {
      var T;
      d && i(!1), (T = t.beforeLeave) == null || T.call(t);
    });
  return m.createElement(M.Provider, {
    value: g
  }, m.createElement(I.Provider, {
    value: a
  }, oe({
    ourProps: _objectSpread(_objectSpread({}, o), {}, {
      as: $,
      children: m.createElement(ue, _objectSpread(_objectSpread(_objectSpread({
        ref: x
      }, o), D), {}, {
        beforeEnter: f,
        beforeLeave: N
      }))
    }),
    theirProps: {},
    defaultTag: $,
    features: le,
    visible: v === "visible",
    name: "Transition"
  })));
}
function _e(t, n) {
  var r = J(I) !== null,
    s = re() !== null;
  return m.createElement(m.Fragment, null, !r && s ? m.createElement(q, _objectSpread({
    ref: n
  }, t)) : m.createElement(ue, _objectSpread({
    ref: n
  }, t)));
}
var q = W(Fe),
  ue = W(He),
  Le = W(_e),
  qe = Object.assign(q, {
    Child: Le,
    Root: q
  });
export { qe as Transition };